import AsyncSelect from 'Common/AsyncSelect/AsyncSelect'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomInput from 'Common/CustomInput/CustomInput'
import CustomLabel from 'Common/CustomLabel/CustomLabel'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import FilterSearch from 'Components/FilterSearch/FilterSearch'
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion'
import React, { useState, useEffect } from 'react'
import { Tooltip } from 'react-tooltip'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'

const RecurrentPaymentSearchForm = ({ 
  searchModel, 
  handleSubmit, 
  handleClear, 
  onHandleChange, 
  setSearchModel,
  handlePaymentId,
  filterCount,
  loading,
  handleFilterSuperSearch,
  superSearchValue,
  activeSubTab
}) => {
  const [activeElement, setActiveElement] = useState(null);
  const [superSearchPatientValue, setSuperSearchPatientValue] = useState('')
  


  const handleToggle = (element) => {
    if (activeElement === element) {
      setActiveElement(null);
    } else {
      setActiveElement(element);
    }
  };

  const handleSelectedData = (selectedObj) => {
    if (selectedObj) {
      setSearchModel((prev) => ({
        ...prev,
        patientid: selectedObj.id,
      }));
      setSuperSearchPatientValue(selectedObj.name);
    } else {
      setSearchModel((prev) => ({
        ...prev, 
        patientid: null,
      }));
      setSuperSearchPatientValue("");
    }
  };

  const handleSuperSearchChange = (value) => {
    setSuperSearchPatientValue(value);
  };

  const handleSearchSubmit = () => {
    handleSubmit(false);
  };

    useEffect(() => {
        if (!searchModel.patientid) {
          setSuperSearchPatientValue('');
        }
      }, [searchModel.patientid]);

  return (
    <div className="mb-4">
      <div className="flex justify-between">
        <Tooltip id={"RecurrentPaymentFormFilterSearch"} style={{ maxWidth: 300, zIndex: 12 }} />
        <div data-tooltip-id={"RecurrentPaymentFormFilterSearch"} data-tooltip-content="Only number values are allowed" className="flex items-center w-[355px]  ">
          <FilterSearch
            filterCount={filterCount}
            activeElement={activeElement}
            handleToggle={handleToggle}
            loading={loading}
            handleFilterSuperSearch={handleFilterSuperSearch}
            superSearchValue={superSearchValue}
            placeholder="Search Account #..."
            isNumeric
          />
        </div>
        {/* <div className="flex gap-4">
          <CustomButtonNew 
            prefixIcon={<PlusIcon />} 
            onClick={handleAddPaymentPlan} 
            label="Add Payment Plan" 
          />
        </div> */}
      </div>
      <SuperAccordion id='recurrentPaymentSearchGrid' show={activeElement === 0}>
        <div className="grid grid-cols-12 gap-4 pt-8 pb-4">
          <div className="col-span-12 md:col-span-2">
            <div className="flex gap-2 pb-2">
              <CustomLabel label="Patient" toolTip="Search by patient account number, patient name, or date of birth (format mm/dd/yyyy)" />
            </div>
            <PatientSuperSearch
              searchValue={superSearchPatientValue}
              onChange={handleSuperSearchChange}
              handleSelectedData={handleSelectedData}
              width='100%'
            />
          </div>
          
          <div className="col-span-12 md:col-span-2">
            <AsyncSelect
              value={searchModel.locationId} 
              name="locationId" 
              onChange={onHandleChange} 
              label="Location"
              apiLink={`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindLocations`}
            />
          </div>

          <div className="col-span-12 md:col-span-2">
            <CustomSelect 
              name="status" 
              value={searchModel.status || ''} 
              onChange={onHandleChange} 
              label="Status"
            >
              <option value="">All</option>
              <option value="Active">Active</option>
              <option value="Paused">Paused</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </CustomSelect>
          </div>

          <div className="col-span-12 md:col-span-2">
            <CustomInput 
              name="paymentDatefrom" 
              type="date" 
              value={searchModel.paymentDatefrom || ''} 
              onChange={onHandleChange} 
              label="Payment Date From" 
            />
          </div>

          <div className="col-span-12 md:col-span-2">
            <CustomInput 
              name="paymentDateto" 
              type="date" 
              value={searchModel.paymentDateto || ''} 
              onChange={onHandleChange} 
              label="Payment Date To" 
            />
          </div>

          <div className="flex justify-end col-span-12 gap-2">
            <CustomButtonNew label="Clear" onClick={handleClear} variant="outline" />
            <CustomButtonNew onClick={handleSearchSubmit} label="Search" />
          </div>
        </div>
      </SuperAccordion>
    </div>
  )
}

export default RecurrentPaymentSearchForm

